/**
 * System Templates - Common (shared across all clinic types)
 *
 * These are read-only, hard-coded treatment-documentation templates
 * available to all therapists. Users can duplicate them to create editable
 * cloud copies.
 *
 * Field shape: { id, label, type, required }
 * Types: short_text | long_text | date | checkbox | radio | multi_select | section_header
 */

import { ALL_CLINIC_TYPE_CODES } from "../../clinicTypesConfig";

export const commonTemplates = [
  {
    id: "sys_tpl_session_summary",
    name: "סיכום מפגש",
    fields: [
      { id: "st_ss_01", type: "short_text", label: "מספר מפגש", required: false },
      { id: "st_ss_02", type: "long_text", label: "מטרת המפגש", required: true },
      { id: "st_ss_03", type: "long_text", label: "מהלך המפגש – מה נעשה", required: true },
      { id: "st_ss_04", type: "long_text", label: "תגובת המטופל/ת ושיתוף פעולה", required: false },
      { id: "st_ss_05", type: "long_text", label: "התקדמות ביחס למטרות הטיפול", required: false },
      { id: "st_ss_06", type: "long_text", label: "המלצות / משימות להמשך", required: false },
      { id: "st_ss_07", type: "long_text", label: "תכנון למפגש הבא", required: false },
    ],
    isSystem: true,
    clinicTypes: ALL_CLINIC_TYPE_CODES,
  },
  {
    id: "sys_tpl_intake",
    name: "אינטייק – מפגש ראשון",
    fields: [
      { id: "st_in_01", type: "section_header", label: "רקע", required: false },
      { id: "st_in_02", type: "long_text", label: "סיבת הפנייה (במילים של המטופל/ת)", required: true },
      { id: "st_in_03", type: "long_text", label: "היסטוריה רלוונטית (רפואית / טיפולית / משפחתית)", required: false },
      { id: "st_in_04", type: "long_text", label: "טיפולים קודמים ותוצאותיהם", required: false },
      { id: "st_in_05", type: "section_header", label: "הערכה", required: false },
      { id: "st_in_06", type: "long_text", label: "התרשמות ראשונית", required: true },
      { id: "st_in_07", type: "long_text", label: "כוחות ומשאבים", required: false },
      { id: "st_in_08", type: "section_header", label: "תוכנית", required: false },
      { id: "st_in_09", type: "long_text", label: "מטרות טיפול מוסכמות", required: true },
      { id: "st_in_10", type: "long_text", label: "תוכנית טיפול ראשונית (תדירות, שיטה, משך משוער)", required: false },
      { id: "st_in_11", type: "checkbox", label: "נחתמו טפסי הסכמה וויתור סודיות", required: false },
    ],
    isSystem: true,
    clinicTypes: ALL_CLINIC_TYPE_CODES,
  },
  {
    id: "sys_tpl_treatment_closure",
    name: "סיכום טיפול (סיום)",
    fields: [
      { id: "st_tc_01", type: "date", label: "תאריך תחילת הטיפול", required: false },
      { id: "st_tc_02", type: "short_text", label: "מספר מפגשים כולל", required: false },
      { id: "st_tc_03", type: "long_text", label: "מטרות הטיפול כפי שהוגדרו", required: true },
      { id: "st_tc_04", type: "long_text", label: "מהלך הטיפול – עיקרי הדברים", required: true },
      { id: "st_tc_05", type: "long_text", label: "השגת המטרות ותוצאות", required: true },
      { id: "st_tc_06", type: "radio", label: "סיבת הסיום", required: false, options: ["השגת המטרות", "בקשת המטופל/ת", "הפניה לגורם אחר", "אחר"] },
      { id: "st_tc_07", type: "long_text", label: "המלצות להמשך", required: false },
    ],
    isSystem: true,
    clinicTypes: ALL_CLINIC_TYPE_CODES,
  },
];
